import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyC1kdfHzeJrJHEJgv9dGi1IJ7jm4Dywg5Y",
  authDomain: "trading-wealth-9f91b.firebaseapp.com",
  projectId: "trading-wealth-9f91b",
  storageBucket: "trading-wealth-9f91b.firebasestorage.app",
  messagingSenderId: "572879094482",
  appId: "1:572879094482:web:36d0382af4cc725394630b",
  measurementId: "G-9Y05SP4CND",
};

const app = initializeApp(firebaseConfig);

const analytics = getAnalytics(app);

const db = getFirestore(app);

const auth = getAuth(app);

export { app, db, auth, analytics };